// app/javascript/controllers/language_switcher_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    switch(event) {
        console.log("Language switcher clicked");
        let newLocale = event.currentTarget.dataset.locale; // Optional explicit locale
        const currentPath = window.location.pathname;
        const currentLocaleMatch = currentPath.match(/^\/(en|bg)(\/|$)/); // Regex to find current locale in path

        let newPath;

        // If no explicit target locale is provided, toggle between en/bg
        if (!newLocale) {
            const current = currentLocaleMatch ? currentLocaleMatch[1] : null;
            newLocale = current === 'bg' ? 'en' : 'bg';
        }

        if (currentLocaleMatch) {
            // Replace existing locale in path
            newPath = currentPath.replace(currentLocaleMatch[1], newLocale);
        } else {
            // No locale in path, prepend new locale (e.g., from /about to /en/about)
            newPath = `/${newLocale}${currentPath}`;
        }

        // Redirect to the new URL
        window.location.href = newPath + window.location.search + window.location.hash;
    }
}
